export default "__VITE_PUBLIC_ASSET__7a3e4b05__"